import { getVideos, likeVideoCount, unlikeVideoCount } from "./videosAPI";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
  videos: [],
  isLoading: false,
  isError: false,
  error: "",
};

// async thunk
export const fetchVideos = createAsyncThunk(
  "videos/fetchVideos",
  async ({ tags, search, pageNo }) => {
    const videos = await getVideos(tags, search, pageNo);
    return videos;
  }
);

export const updatesLikeCount = createAsyncThunk(
  "videos/updateLike",
  async ({ id, data, cb }) => {
    const res = await likeVideoCount(id, data);
    if (res?.status === 200) {
      cb && cb();
    }
    return res.data;
  }
);

export const updatesUnlikeCount = createAsyncThunk(
  "videos/updateUnlike",
  async ({ id, data, cb }) => {
    const res = await unlikeVideoCount(id, data);
    if (res?.status === 200) {
      cb && cb();
    }
    return res.data;
  }
);

const videoSlice = createSlice({
  name: "videos",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchVideos.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(fetchVideos.fulfilled, (state, action) => {
        state.isLoading = false;
        state.videos = action.payload;
      })
      // update
      // .addCase(updatesLikeCount.fulfilled, (state, action) => {
      //   // const index = state.videos.findIndex(
      //   //   (video) => video.id === action.payload.id
      //   // );
      //   // state.videos[index] = {
      //   //   ...state.videos[index],
      //   //   ...action.payload,
      //   // };
      // })
      .addCase(fetchVideos.rejected, (state, action) => {
        state.isLoading = false;
        state.videos = [];
        state.isError = true;
        state.error = action.error?.message;
      });
  },
});

export default videoSlice.reducer;
